const onKeyDown = (e) => {
    preventScrollWhenSelect2Open(e);
}

// This code is used to stop the page from scrolling up/down if the user has a select2 open. This is checked using a class that is applied to the body.
const preventScrollWhenSelect2Open = (e) => {
    if (e.key == 'ArrowUp' || e.key == 'ArrowDown') {
        const isSelect2Open = document.body.classList.contains('select2-dropdown-open');
        if (isSelect2Open == false) return;

        e.preventDefault();
        e.stopPropagation();
        return false;
    }
}

const init = () => {
    document.addEventListener('keydown', onKeyDown);
}

export {
    init,
}